import CreateIcon from './CreateIcon'

export default CreateIcon;


// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/CreateIcon/index.js